/* pz3-vivi.js (da VIVA/vivi.js, P2-VIVA) · Pozzalume · il Teatrino di carta prende vita (24/10/2026)
   Le scariche del Musone (a caso, solo quando si vede), i tocchi sui personaggi (la Torta scappa, Viola e Amara
   fanno un saltello, il Musone brontola, il Mulinello gira veloce e grida "Gioca con me!", Luna sbuffa,
   Nasobrontolo annusa, Vecchio Silenzio russa), le sette lanterne del mondo da riaccendere, il biglietto che
   invita alla musica, il cartellino del brano che suona, i cicli fermi fuori schermo, la modalita' leggera. Le voci passano da window.__suoni (suoni.js): a suoni spenti
   i personaggi si muovono e basta. Senza JavaScript, o con movimento ridotto, tutto resta in una posa ferma. */
(function () {
  'use strict';
  var d = document, w = window;
  var ridotto = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function voce(nome, p) { if (w.__suoni) w.__suoni.suona(nome, p); }
  function anima(el, k, o) { if (el && el.animate && !ridotto) { try { return el.animate(k, o); } catch (e) {} } return null; }
  function leggero() { return d.documentElement.classList.contains('leggero'); }
  // le frasi le scrive Liquid sul cartellino del brano (snippets/pz3-brani.liquid, pz3.vivi): qui nessun testo
  var CART = d.querySelector('[data-brano-cartellino]');
  function frase(k) { return (CART && CART.getAttribute('data-' + k)) || ''; }

  /* ---------- fermi fuori schermo: i cicli girano solo dove si guarda ---------- */
  var scene = $$('.palco, .offerta__scena, .diorama, .inverno, .bundle--neve');
  var inVista = new Set();
  if ('IntersectionObserver' in w) {
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (x.isIntersecting) { x.target.removeAttribute('data-fermo'); inVista.add(x.target); }
        else { x.target.setAttribute('data-fermo', ''); inVista.delete(x.target); }
      });
    }, { rootMargin: '80px 0px 80px 0px' });
    scene.forEach(function (s) { io.observe(s); });
  }

  /* ---------- il Musone: scariche a caso, solo su quello che si vede ---------- */
  function scocca(lampi, tocco) {
    if (!lampi || ridotto) return;
    lampi.classList.remove('scocca');
    void lampi.getBoundingClientRect();
    lampi.classList.add('scocca');
    setTimeout(function () { lampi.classList.remove('scocca'); }, 900);
    var nuvola = lampi.nextElementSibling;  // i lampi stanno sotto la nuvola
    anima(nuvola, [{ scale: '1' }, { scale: '1.06 .93' }, { scale: '.97 1.04' }, { scale: '1' }], { duration: 480, easing: 'ease-out' });
    try { d.dispatchEvent(new CustomEvent('pz:scarica', { detail: { tocco: !!tocco } })); } catch (e) {}
  }
  function prossimaScarica() {
    setTimeout(function () {
      if (!d.hidden) {
        var visti = $$('.lampi').filter(function (l) {
          var s = l.closest('.palco, .offerta__scena, .diorama');
          if (!s || !inVista.has(s) || l.classList.contains('scacciato')) return false;
          var r = l.getBoundingClientRect();
          return r.bottom > 0 && r.top < w.innerHeight;
        });
        if (visti.length) scocca(visti[Math.floor(Math.random() * visti.length)]);
      }
      prossimaScarica();
    }, (2600 + Math.random() * 3200) * (leggero() ? 1.8 : 1));
  }
  if (!ridotto) setTimeout(prossimaScarica, 2400);

  /* ---------- i tocchi sui personaggi ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var musone = t.closest('.palco__musone:not(.lampi), .diorama__musone:not(.lampi)');
    if (musone) {
      voce('musone');
      var l = musone.previousElementSibling;
      if (l && l.classList.contains('lampi')) setTimeout(function () { scocca(l, true); }, 420);
      return;
    }
    var torta = t.closest('.palco__eroe--torta');
    if (torta) {
      voce('torta');
      anima(torta, [
        { transform: 'translate(0, 0) rotate(0)' }, { transform: 'translate(-14px, -16px) rotate(-10deg)', offset: .25 },
        { transform: 'translate(-26px, 0) rotate(-6deg)', offset: .5 }, { transform: 'translate(-12px, -10px) rotate(6deg)', offset: .75 },
        { transform: 'translate(0, 0) rotate(0)' }
      ], { duration: 640, easing: 'ease-out' });
      return;
    }
    var eroe = t.closest('.palco__eroe, .domande__eroe');
    if (eroe) {
      voce('saltello', { tono: eroe.classList.contains('palco__eroe--viola') ? 1.06 : 1 });
      anima(eroe, [
        { transform: 'translateY(0) rotate(0)' }, { transform: 'translateY(-22px) rotate(-5deg)', offset: .4 },
        { transform: 'translateY(0) rotate(3deg)', offset: .75 }, { transform: 'translateY(0) rotate(0)' }
      ], { duration: 560, easing: 'cubic-bezier(.34, 1.56, .64, 1)' });
      return;
    }
    var mul = t.closest('[data-mulinello]');
    if (mul) {
      voce('mulinello');
      anima(mul.querySelector('.mulinello__corpo'), [
        { transform: 'perspective(420px) rotateY(0deg) rotate(-6deg)' },
        { transform: 'perspective(420px) rotateY(1440deg) rotate(6deg)', offset: .8 },
        { transform: 'perspective(420px) rotateY(1440deg) rotate(0deg)' }
      ], { duration: 1300, easing: 'cubic-bezier(.3, 0, .2, 1)' });
      parla(mul, 1800);
    }
  });

  /* ---------- il Mulinello dice "Gioca con me!" a ogni secondo giro, e quando lo si tocca ---------- */
  function parla(mul, quanto) {
    mul.classList.add('parla');
    clearTimeout(mul.__parla);
    mul.__parla = setTimeout(function () { mul.classList.remove('parla'); }, quanto);
  }
  if (!ridotto) {
    $$('[data-mulinello]').forEach(function (mul) {
      var corpo = mul.querySelector('.mulinello__corpo'), giri = 0;
      if (!corpo) return;
      corpo.addEventListener('animationiteration', function () {
        giri++;
        if (giri % 2 === 0) setTimeout(function () { parla(mul, 1900); }, 300);
      });
      corpo.addEventListener('animationstart', function () { setTimeout(function () { parla(mul, 1900); }, 300); });
    });
  }

  /* ---------- il cartellino del brano: cosa suona adesso il carillon ---------- */
  var cart = d.querySelector('[data-brano-cartellino]'), nome = cart && cart.querySelector('.brano__nome'), tmr = 0;
  d.addEventListener('pz:brano', function (e) {
    if (!cart || !nome || !e.detail) return;
    var li = d.querySelector('.brani [data-brano="' + e.detail.brano + '"]');
    if (!li) return;
    if (nome.textContent === li.textContent && cart.classList.contains('mostra')) return;
    nome.textContent = li.textContent;
    cart.classList.add('mostra');
    clearTimeout(tmr);
    tmr = setTimeout(function () { cart.classList.remove('mostra'); }, 3200);
  });
  d.addEventListener('suoni:spento', function () { if (cart) cart.classList.remove('mostra'); });

  /* ---------- modalita' leggera: sui telefoni che faticano restano solo i movimenti principali ---------- */
  // La testa della pagina la accende gia' con "risparmio dati" o con pochi processori. Qui si misurano 90 fotogrammi
  // mentre il palco si muove: se la mediana passa 25 ms (sotto 40 al secondo) o salta un fotogramma su tre,
  // si fermano i cicli di contorno (vivi.css, html.leggero) e le scariche diventano piu' rade.
  function misuraFotogrammi() {
    if (ridotto || leggero() || !w.requestAnimationFrame) return;
    var tempi = [], prima = 0;
    function passo(t) {
      if (d.hidden) return;
      if (prima) tempi.push(t - prima);
      prima = t;
      if (tempi.length < 90) { w.requestAnimationFrame(passo); return; }
      var o = tempi.slice().sort(function (a, b) { return a - b; }), mediana = o[45];
      var lunghi = tempi.filter(function (x) { return x > 34; }).length / tempi.length;
      w.__pzFotogrammi = { mediana: Math.round(mediana * 10) / 10, lunghi: Math.round(lunghi * 100) / 100 };
      if (mediana > 25 || lunghi > 0.33) d.documentElement.classList.add('leggero');
    }
    w.requestAnimationFrame(passo);
  }
  setTimeout(misuraFotogrammi, 1400);

  /* ---------- l'invito alla musica: un biglietto del teatrino appeso al carillon ---------- */
  // Diego: "una scritta piccola e figa all'inizio, che non si scontri col banner dei cookie". Il biglietto pende
  // dall'interruttore in alto (la merenda dei cookie sta in basso), scende dondolando e al tocco accende la musica.
  // Se ne va da solo quando si sceglie, quando si scorre o dopo 9 secondi. Una volta per visita. E' solo un aiuto
  // per gli occhi: per chi usa un lettore di schermo c'e' gia' l'interruttore vero.
  // MG-SITO V4 (29/10): arriva solo dopo il primo scorrimento (all'arrivo la prima schermata resta al gioco e al prezzo)
  // e mai sopra la foto del prodotto: se il biglietto toccherebbe la galleria della scheda, aspetta che la foto esca.
  // Se ne va al tocco, con la musica accesa, dopo 9 secondi o dopo un altro bel tratto di pagina.
  function invito() {
    var bott = d.querySelector('.testata [data-suono-interruttore]');
    if (!bott || bott.getAttribute('aria-pressed') === 'true' || d.documentElement.classList.contains('resa')) return;
    try { if (w.sessionStorage.getItem('pz-invito')) return; } catch (e) {}
    // MG-SITO idea 4: solo dove si sceglie il gioco (home e scheda): nel carrello e nelle pagine di servizio non disturba
    if (!/pz-tipo-(index|product)/.test(d.body.className)) return;
    var fatto = false, attesa = 0;
    var smetti = function () { w.removeEventListener('scroll', guarda); };
    var guarda = function () { if (!attesa) attesa = setTimeout(function () { attesa = 0; prova(); }, 160); };
    function prova() {
      if (fatto) return;
      if (bott.getAttribute('aria-pressed') === 'true') { fatto = true; smetti(); return; }
      if (w.scrollY < 80 || d.querySelector('#pz-cassetto[open]')) return;
      var r = bott.getBoundingClientRect();
      if (!r.width || r.bottom < 0) return;
      var largo = Math.min(214, w.innerWidth - 32), centro = r.left + r.width / 2;
      var sx = Math.max(16, Math.min(centro - largo / 2, w.innerWidth - 16 - largo)), sopra = r.bottom - 3;
      // MG-SITO idea 1 (29/10): nemmeno sopra titoli, prezzi, scelta dell'edizione o bottoni (dal giro a 375 copriva il prezzo
      // della scheda): se sotto il biglietto c'e' uno di questi, aspetta il prossimo tratto di pagina.
      var sotto = d.querySelectorAll('.pz-galleria, h1, h2, h3, .prezzo, [data-pz-scelta], .bottone, button[type="submit"], main a, figcaption');
      for (var i = 0; i < sotto.length; i++) {
        var f = sotto[i].getBoundingClientRect();
        if (f.width && f.bottom > sopra && f.top < sopra + 90 && f.right > sx && f.left < sx + largo) return;
      }
      fatto = true; smetti();
      try { w.sessionStorage.setItem('pz-invito', '1'); } catch (e) {}
      mostra(bott, sx, largo, centro, sopra);
    }
    w.addEventListener('scroll', guarda, { passive: true });
  }
  function mostra(bott, sx, largo, centro, sopra) {
    var b = d.createElement('div');
    b.className = 'invito'; b.setAttribute('aria-hidden', 'true');
    b.style.cssText = 'top:' + Math.round(sopra) + 'px;left:' + Math.round(sx) + 'px;width:' + largo + 'px;--filo:' + Math.round(centro - sx) + 'px';
    b.innerHTML = '<span class="invito__filo"></span><span class="invito__biglietto"><span class="invito__su"></span>' +
      '<span class="invito__giu"></span></span>';
    b.querySelector('.invito__su').textContent = frase('invito-su');
    b.querySelector('.invito__giu').textContent = frase('invito-giu');
    d.body.appendChild(b);
    var y0 = w.scrollY;
    var scorri = function () { if (Math.abs(w.scrollY - y0) > w.innerHeight * 0.8) via(); };
    var via = function () {
      if (!b.parentNode || b.classList.contains('via')) return;
      b.classList.add('via'); bott.classList.remove('invita');
      w.removeEventListener('scroll', scorri);
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 450);
    };
    b.addEventListener('click', function () { if (bott.getAttribute('aria-pressed') !== 'true') bott.click(); via(); });
    d.addEventListener('suoni:acceso', via);
    w.addEventListener('scroll', scorri, { passive: true });
    setTimeout(via, 9000);
    void b.offsetWidth;
    b.classList.add('su'); bott.classList.add('invita');
  }
  if (d.readyState === 'complete') setTimeout(invito, 1500);
  else w.addEventListener('load', function () { setTimeout(invito, 1200); });

  /* ---------- il mondo: il Musone spegne le lanterne, chi guarda le riaccende ---------- */
  // La storia del gioco ("stasera tutte le lanterne del paese si sono spente") diventa un gesto. Quando il diorama
  // si vede bene il Musone scarica e le sette lanterne si spengono una dopo l'altra; ogni tocco ne riaccende una e
  // suona la nota dopo del tema di Pozzalume (in qualunque ordine si tocchino, esce l'inizio del tema). A sette il
  // Musone se ne va, Luna fa un salto, la musica passa alla festa e il cartellino ricorda la cosa gentile per Luna,
  // come alla fine del gioco vero. Senza JavaScript o con "riduci movimento" le lanterne restano accese e ferme.
  var NOTE = [79, 84, 88, 86, 84, 81, 84];
  var dio = d.querySelector('.diorama');
  if (dio && !ridotto && 'IntersectionObserver' in w && !d.documentElement.classList.contains('resa')) {
    var lanterne = $$('.diorama__lanterna', dio), accese = 0, partito = false, finito = false;
    var conta = d.createElement('p');
    conta.className = 'diorama__gioco';
    conta.innerHTML = '<span data-gioco-testo></span> <b><span data-accese>0</span> <span data-gioco-di></span> ' + lanterne.length + '</b>';
    conta.querySelector('[data-gioco-testo]').textContent = frase('gioco');
    conta.querySelector('[data-gioco-di]').textContent = frase('gioco-di');
    dio.appendChild(conta);
    lanterne.forEach(function (l) {
      var lume = d.createElement('span');
      lume.className = 'diorama__lume';
      lume.setAttribute('style', l.getAttribute('style') || '');
      l.parentNode.insertBefore(lume, l);
      l.__lume = lume;
    });
    var spegni = function () {
      if (partito) return;
      partito = true;
      var lampi = dio.querySelector('.lampi');
      if (lampi) scocca(lampi, true);
      voce('musone');
      lanterne.forEach(function (l, i) { setTimeout(function () { l.classList.add('spenta'); }, 380 + i * 150); });
      setTimeout(function () { conta.classList.add('mostra'); }, 380 + lanterne.length * 150 + 200);
    };
    new IntersectionObserver(function (v) {
      if (!partito && v[0].isIntersecting && v[0].intersectionRatio >= 0.55) setTimeout(spegni, 600);
    }, { threshold: [0, 0.55] }).observe(dio);
    var festa = function () {
      finito = true;
      $$('.diorama__musone', dio).forEach(function (m) { m.classList.add('scacciato'); });
      dio.classList.add('festa');
      voce('festa');
      conta.querySelector('[data-gioco-testo]').textContent = frase('festa');
      conta.classList.add('vinto');
      anima(dio.querySelector('.diorama__luna'), [{ transform: 'translateY(0) rotate(0)' }, { transform: 'translateY(-26px) rotate(-6deg)', offset: .35 },
        { transform: 'translateY(0) rotate(3deg)', offset: .7 }, { transform: 'translateY(-10px) rotate(0)', offset: .85 }, { transform: 'translateY(0) rotate(0)' }],
        { duration: 1100, delay: 500, easing: 'ease-out' });
      var zona = dio.closest('[data-zona]');
      if (zona) zona.setAttribute('data-zona', 'festa');
      if (w.__suoni) w.__suoni.ambiente('zona', 'festa');
    };
    dio.addEventListener('click', function (e) {
      if (!partito || finito) return;
      // la lanterna spenta piu' vicina al dito, entro 44 px: i bambini toccano larghi. Vince anche se il dito
      // cade sul Musone o su Luna (una lanterna sta sotto la nuvola): allora la loro voce non parte
      var meglio = null, dist = 44;
      lanterne.forEach(function (l) {
        if (!l.classList.contains('spenta')) return;
        var r = l.getBoundingClientRect(), dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2), q = Math.sqrt(dx * dx + dy * dy);
        if (q < dist) { dist = q; meglio = l; }
      });
      if (!meglio) return;
      e.stopPropagation();
      meglio.classList.remove('spenta');
      meglio.__lume.classList.add('acceso');
      anima(meglio, [{ scale: '.8' }, { scale: '1.25' }, { scale: '1' }], { duration: 520, easing: 'cubic-bezier(.34, 1.56, .64, 1)' });
      voce('lanterna', { nota: NOTE[accese % NOTE.length] });
      accese++;
      conta.querySelector('[data-accese]').textContent = accese;
      if (accese >= lanterne.length) festa();
    });
  }

  /* ---------- Luna, Nasobrontolo e Vecchio Silenzio ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var luna = t.closest('.diorama__luna');
    if (luna) {
      voce('luna');
      anima(luna, [{ transform: 'translateY(0) scale(1)' }, { transform: 'translateY(-14px) scale(1.06, .95)', offset: .3 },
        { transform: 'translateY(0) scale(.97, 1.04)', offset: .65 }, { transform: 'translateY(0) scale(1)' }], { duration: 620, easing: 'ease-out' });
      return;
    }
    var naso = t.closest('.domande__eroe');
    if (naso) {
      voce('naso');
      anima(naso, [{ transform: 'scale(1)' }, { transform: 'scale(1.04, .94)', offset: .12 }, { transform: 'scale(1)', offset: .22 },
        { transform: 'scale(1.04, .94)', offset: .34 }, { transform: 'scale(1)', offset: .46 }, { transform: 'scale(1.04, .94)', offset: .58 },
        { transform: 'scale(1) translateY(-10px)', offset: .8 }, { transform: 'scale(1)' }], { duration: 1100, easing: 'ease-out' });
      var luccica = naso.parentNode.querySelector('.naso__luccica');
      if (luccica && !ridotto) { luccica.classList.remove('vola'); void luccica.offsetWidth; luccica.classList.add('vola'); }
      return;
    }
    var plancia = t.closest('.inverno .tavolo__pezzo--plancia');
    if (plancia) {
      voce('russa');
      var z = plancia.querySelector('.zeta');
      if (z && !ridotto) { z.classList.remove('forte'); void z.offsetWidth; z.classList.add('forte'); setTimeout(function () { z.classList.remove('forte'); }, 2600); }
    }
  });
  // Nasobrontolo raccoglie cose luccicanti: la scintilla che gli vola in mano al tocco
  var nasoImg = d.querySelector('.domande__eroe');
  if (nasoImg && frase('scintilla')) {
    var lc = d.createElement('img');
    lc.className = 'naso__luccica'; lc.src = frase('scintilla'); lc.alt = ''; lc.width = 120; lc.height = 121;
    lc.setAttribute('aria-hidden', 'true'); lc.loading = 'lazy';
    nasoImg.parentNode.insertBefore(lc, nasoImg.nextSibling);
  }
  // Vecchio Silenzio dorme sulla sua plancia: tre zeta di carta salgono dal naso (posizione presa sul disegno vero)
  var plancia = d.querySelector('.inverno .tavolo__pezzo--plancia');
  var planciaImg = plancia && plancia.querySelector('img');
  if (planciaImg) {
    var zz = d.createElement('span');
    zz.className = 'zeta'; zz.setAttribute('aria-hidden', 'true');
    zz.innerHTML = '<i>z</i><i>z</i><i>Z</i>';
    plancia.appendChild(zz);
    var metti = function () {
      if (!planciaImg.offsetWidth) return;
      zz.style.left = (planciaImg.offsetLeft + planciaImg.offsetWidth * 0.73) + 'px';
      zz.style.top = (planciaImg.offsetTop + planciaImg.offsetHeight * 0.5) + 'px';
      zz.style.setProperty('--u', (planciaImg.offsetWidth / 100).toFixed(2) + 'px');
    };
    if (planciaImg.complete) metti(); else planciaImg.addEventListener('load', metti);
    w.addEventListener('resize', metti, { passive: true });
    if ('IntersectionObserver' in w) new IntersectionObserver(function (v) { if (v[0].isIntersecting) metti(); }).observe(plancia);
  }
  /* ---------- MG-SITO (29/10): le porte e la lanterna dei telefoni entrano quando si vedono ----------
     pronta la mette solo questo script e solo a cio' che e' ancora sotto lo schermo: senza JS, con movimento ridotto
     o gia' in vista all'arrivo restano ferme e aperte (pz3.css, blocco MG-SITO). */
  var entra = $$('[data-pz-entra]');
  if (entra.length && !ridotto && 'IntersectionObserver' in w && !d.documentElement.classList.contains('resa')) {
    var ioE = new IntersectionObserver(function (v) {
      v.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('entrata'); ioE.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    entra.forEach(function (el) {
      // una sezione ancora nascosta (le finestre di data di pz-vendita.js) misura 0: si prepara comunque
      var r = el.getBoundingClientRect();
      if (r.height && r.top < w.innerHeight * 0.88) return;
      el.classList.add('pronta'); ioE.observe(el);
    });
  }
})();
